/* eslint-disable */
export const integrations = { All: true, Intercom: false, WebEngage: true };

/**
 * from https://segment.com/docs/libraries/analytics.js/quickstart/#step-1-copy-the-snippet
 * segment.io's analytics library works best when the `analytics` object
 * is treated as a global object (i.e. `window.analytics`). Therefore,
 * this library won't return anything. It just sets up the global object.
 * @param  {string} apiKey
 */
const setupSegment = (apiKey) => {
  // Create a queue, but don't obliterate an existing one!
  window.analytics = window.analytics || [];
  const analytics = window.analytics;

  // If the real analytics.js is already on the page return.
  if (analytics.initialize) return analytics;

  // If the snippet was invoked already show an error.
  if (analytics.invoked) {
    if (window.console && console.error) {
      console.error('Segment snippet included twice.');
    }
    return analytics;
  }

  // Invoked flag, to make sure the snippet
  // is never invoked twice.
  analytics.invoked = true;

  // A list of the methods in Analytics.js to stub.
  analytics.methods = [
    'trackSubmit',
    'trackClick',
    'trackLink',
    'trackForm',
    'pageview',
    'identify',
    'group',
    'track',
    'ready',
    'alias',
    'page',
    'once',
    'off',
    'on',
  ];

  // Define a factory to create stubs. These are placeholders
  // for methods in Analytics.js so that you never have to wait
  // for it to load to actually record data. The `method` is
  // stored as the first argument, so we can replay the data.
  analytics.factory = function (method) {
    return function () {
      const args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      analytics.push(args);
      return analytics;
    };
  };

  // For each of our methods, generate a queueing stub.
  for (let i = 0; i < analytics.methods.length; i++) {
    const key = analytics.methods[i];
    analytics[key] = analytics.factory(key);
  }

  // Define a method to load Analytics.js from our CDN
  analytics.load = (key) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `${document.location.protocol === 'https:' ?
      'https://' :
      'http://'}cdn.segment.com/analytics.js/v1/${key}/analytics.min.js`;

    // Insert our script next to the first script element.
    const first = document.getElementsByTagName('script')[0];
    first.parentNode.insertBefore(script, first);
  };

  // Add a version to keep track of what's in the wild.
  analytics.SNIPPET_VERSION = '3.0.1';

  // Load Analytics.js with correct key for environment
  analytics.load(apiKey);

  return analytics;
};

/**
 * Adds optimizely to the page
 */
function LoadOptimizely() {
  const optScript = document.createElement('script');
  optScript.type = 'text/javascript';
  optScript.src = `${document.location.protocol === 'https:'
    ? 'https://' : 'http://'
    }cdn.optimizely.com/js/72168671.js`;
  const first = document.getElementsByTagName('script')[0];
  first.parentNode.insertBefore(optScript, first);
}

let analyticsLoaded = false;
/**
 * Loads segment analytics
 * @param  {object} userInfo
 * @param  {string} apiKey
 */
const LoadAnalytics = (userInfo, apiKey) => {
  // only load analytics once
  if (analyticsLoaded) {
    return false;
  }

  //consider removing after GROW-302, GROW-81, GROW-439 testing is finished
  if (process.env.SIGNUP_MAKO_OPTIMIZELY === 'true') {
    LoadOptimizely();
  }

  const analytics = setupSegment(apiKey);

  if (userInfo) {
    analytics.identify(userInfo.user_id, {
      email: userInfo.email,
      username: userInfo.username,
      package: userInfo.pkg,
    }, { integrations });
  }

  // always track initial page visit
  analytics.page(undefined, undefined, undefined, { integrations });

  analytics.ready(() => {
    // eslint-disable-next-line
    if (!window._weq) return; // make sure webengage is enabled

    // TODO: get this working
    // http://docs.webengage.com/sdks/web/older_v4_docs/readme.html
    // window._weq['webengage.onReady'] = () => {
    //   window._weq['webengage.customData'] = {
    //     user_id: userInfo ? userInfo.user_id : undefined,
    //     package: userInfo ? userInfo.pkg : undefined,
    //   };
    // };
  });

  window.analytics = analytics;
  analyticsLoaded = true;
  return analyticsLoaded;
};

const getLowerPkgName = (pkgName) => {
  return pkgName ?
    pkgName.replace(/ /g, '-')
      .toLowerCase() :
    '';
};

/**
 * Adds user info to google tag manager
 * @param  {int} id
 * @param  {string} email
 * @param  {object} activePkg
 */
export const pushGTM = (id, email, activePkg) => {
  const strId = id.toString();
  const lowerPkgName = getLowerPkgName(activePkg.name);

  const optimizelyNamesMap = window['optimizely'] && window['optimizely'].get('state') ?
    window['optimizely'].get('state').getVariationMap() :
    {};

  let numericPrice = parseFloat(activePkg.base_price);
  if (isNaN(numericPrice)) {
    numericPrice = 0.0;
  }

  if (window.dataLayer) {
    window.dataLayer.push({
      'event': 'userSignup',
      'transactionAffiliation': 'variationNamesMap',
      'sgid': strId || '',
      'uid': email,
      'transactionId': `${strId}-${lowerPkgName}`,
      'transactionProducts': [{
        'sku': lowerPkgName,
        'name': strId || '',
        'category': JSON.stringify(optimizelyNamesMap),
        'price': activePkg.base_price,
        'quantity': 1,
      }],
      'package': lowerPkgName,
      'price': activePkg.base_price,
      'transactionTotal': numericPrice,
    });

    window.dataLayer.push({
      'event': 'package',
      'eventAction': lowerPkgName,
      'package': lowerPkgName,
      'price': activePkg.base_price,
      'eventLabel': 'transactional',
    });
  }
};


export default LoadAnalytics;



// WEBPACK FOOTER //
// ./src/utils/Analytics.js